import React, { Component } from 'react';

export default class TextArea extends Component {
  state = { permittedRows: 1 };

  handleKeyUp = e => {
    const currentValue = e.currentTarget.value;
    const maxRows = e.currentTarget.rows;
    const lineCount = currentValue.split('\n').length;

    // Increase TextArea size when the user reaches the end of the first line
    this.setState({ permittedRows: currentValue.length > 19 ? 2 : 1 });

    // User shouldn't be able to press enter if the line number reaches its maximum
    if (lineCount >= maxRows && e.which === 13) {
      e.preventDefault();
    }
  }

  render() {
    return (
      <textarea
        rows={this.state.permittedRows}
        onKeyUp={this.handleKeyUp}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/TextArea.js